import $ from "jquery";
import Swiper from "swiper";
import {
  Navigation,
  A11y,
  Keyboard,
  EffectFade,
  Pagination,
} from "swiper/modules";

export const init = function () {

  $(".ctype-ce_numbers_info_teaserbox").each(function () {
    let currentIndex = 0;
    let $this = $(this);
    let cID = $this.attr("id");
    let id = $this.find(".swiper-nit-slider").attr("id");
    let $thumbBtnPrev = $this.find(".thumbnail-swiper-prev");
    let $thumbBtnNext = $this.find(".thumbnail-swiper-next");
    let $thumbnails = $this.find(".thumbnail-container button.thumbnail");

    let nitSlider = new Swiper("#" + id, {
      modules: [Navigation, A11y, Keyboard, EffectFade, Pagination],
      effect: "fade",
      navigation: {
        nextEl: "#" + cID + " .swiper-nit-slider-next",
        prevEl: "#" + cID + " .swiper-nit-slider-prev",
      },
      pagination: {
        el: "#" + cID + " .swiper-pagination",
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return "" + current + " von " + total + "";
        },
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      fadeEffect: { crossFade: true },
      on: {
        afterInit: function () {
          $("#" + cID).addClass("slider-init");
        },
      },
    });

    $this.find("button.thumbnail").on("click", function (e) {
      let index = $(this).data("index");
      $(this).parent().find("button").removeClass("active");
      $(this).addClass("active");
      nitSlider.slideTo(parseInt(index));
      currentIndex = index;
      updateSlider(currentIndex);
    });

    $thumbBtnPrev.css('opacity', '50%');

    const updateSlider = (index) => {
      $thumbnails.removeClass("active");
      $thumbnails.eq(index).addClass("active");
      nitSlider.slideTo(index);

      if (currentIndex === 0) {
        $thumbBtnPrev.css('opacity', '50%');
        $thumbBtnNext.css('opacity', '');
      } else if (currentIndex === ($thumbnails.length - 1)) {
        $thumbBtnNext.css('opacity', '50%');
        $thumbBtnPrev.css('opacity', '');
      } else {
        $thumbBtnPrev.css('opacity', '');
        $thumbBtnNext.css('opacity', '');
      }
    }

    $thumbBtnPrev.on("click", function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider(currentIndex);
      }
    });

    $thumbBtnNext.on("click", function () {
      if (currentIndex < ($thumbnails.length - 1)) {
        currentIndex++;
        updateSlider(currentIndex);
      }
    });
  });
};
